import { fetchMetrics, getLinkDemoHost } from '../../lib/link-demo-utils';

export const fetchTransferLinkToken = async (
  {
    selectedCountryCode,
    selectedLanguage,
    selectedProduct,
    isAuthTypeSelectEnabled,
  },
  {
    signal,
  }:
    | {
        signal: AbortSignal;
      }
    | undefined,
) => {
  const metrics = await fetchMetrics();
  const endpoint = new URL(getLinkDemoHost() + '/transfer-link-token');
  endpoint.searchParams.append('metrics_id', metrics.id);
  endpoint.searchParams.append('country_codes', selectedCountryCode);
  endpoint.searchParams.append('language', selectedLanguage);
  endpoint.searchParams.append('products', selectedProduct);
  endpoint.searchParams.append(
    'auth_type_select_enabled',
    selectedProduct === 'auth' &&
      selectedCountryCode === 'US' &&
      isAuthTypeSelectEnabled,
  );

  try {
    const linkTokenResp = await fetch(endpoint.href, { signal });
    const linkToken = await linkTokenResp.json();
    return linkToken;
  } catch (e) {
    if (e.name === 'AbortError') return;
    throw new Error(`Error fetching link token: ${e}`);
  }
};

export const fetchCheckingAccounts = async (publicToken) => {
  const endpoint = new URL(getLinkDemoHost() + '/accounts');
  endpoint.searchParams.append('public_token', publicToken);
  endpoint.searchParams.append('product', 'auth');
  endpoint.searchParams.append('use_transfer_prod_client', 'true');

  try {
    const accountsResp = await fetch(endpoint.href);
    const accounts = await accountsResp.json();
    if (accounts.error_code != null) {
      return null;
    }

    for (let i = 0; i < accounts.accounts.length; i++) {
      if (accounts.accounts[i].subtype === 'checking') {
        return accounts.accounts[i];
      }
    }
  } catch (e) {
    if (e.name === 'AbortError') return;
    throw new Error(`Error fetching checking account: ${e}`);
  }
};
